<template>
	<el-dialog
		v-model="dialogVisible"
		:show-close="false"
		:width="config.width || '800px'"
		:modal="config.modal === false ? config.modal : true"
		:lock-scroll="config.lockScroll === false ? config.lockScroll : true"
		:close-on-click-modal="config.closeOnClickModal === false ? config.closeOnClickModal : true"
		:close-on-press-escape="config.closeOnPressEscape === false ? config.closeOnPressEscape : true"
		class="my_custom_dialog"
		:before-close="handleClose"
	>
		<template #header="{ close, titleId, titleClass }">
			<div class="my_header">
				<div :id="titleId" :class="titleClass" class="title">{{ dialogTitle }}</div>
				<el-icon @click="close" :size="16" color="#8087A0" class="close_icon"><Close /></el-icon>
			</div>
		</template>
		<div class="my_content_wrap">
			<slot name="content"></slot>
		</div>
		<div class="my_footer_wrap">
			<slot name="footer"></slot>
		</div>
	</el-dialog>
</template>

<script setup>
	import { defineModel } from "vue";

	const props = defineProps({
		dialogTitle: {
			type: String,
			default: "",
		},
		config: {
			type: Object,
			default: {},
		},
	});

	const dialogVisible = defineModel("dialogVisible");

	const handleClose = () => {
		dialogVisible.value = false;
	};
</script>

<style lang="scss">
	@import "@/assets/css/public.scss";
	.my_custom_dialog {
		height: 678px;
		@include background_color("background");
		box-shadow: 0px 2px 12px 0px rgba(11, 16, 29, 0.1);
		border-radius: 6px;
		padding: 0;
		position: relative;
		.el-dialog__header {
			padding-bottom: 0;
		}
		.my_header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 66px;
			@include background_color("background_block");
			border-radius: 6px 6px 0px 0px;
			padding: 20px;
			box-sizing: border-box;
			.title {
				font-weight: 600;
				font-size: 16px;
				color: #8087a0;
			}
			.close_icon {
				cursor: pointer;
			}
		}
		.my_content_wrap {
			margin: 30px 20px;
			overflow: auto;
			max-height: 480px;
			@extend .common_scrollbar;
		}
		.my_footer_wrap {
			position: absolute;
			bottom: 40px;
			width: 100%;
			text-align: center;
		}
	}
</style>
